import { render, staticRenderFns } from "./leave-project.vue?vue&type=template&id=9a14ded2"
import script from "./leave-project.vue?vue&type=script&lang=js"
export * from "./leave-project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports